module.exports = __webpack_public_path__ + "img/logo_hubbell.66496b87.png";